import { jsx } from 'react/jsx-runtime';
import { getSystemTimeZone, ISO_DATE_TIME_PART_FORMAT, ISO_DATE_PART_FORMAT, ISO_TIME_PART_FORMAT } from '@flex-packages/date';
import formatInTimeZone from 'date-fns-tz/formatInTimeZone';
import { forwardRef } from 'react';
import { useFormat } from '../../hooks/useFormatV2.mjs';

const Time = forwardRef((props, ref) => {
  const { presetName, date, locale, ...timeProps } = props;
  const format = useFormat({ locale });
  const dateTime = formatInTimeZone(
    date,
    getSystemTimeZone(),
    formatStringForDateTimeRecord[presetName]
  );
  return /* @__PURE__ */ jsx("time", { ref, dateTime, ...timeProps, children: format(props) });
});
const formatStringForDateTimeRecord = {
  // 요일
  weekday: "EEEE",
  weekday_short: "EEE",
  // 시간
  time: ISO_TIME_PART_FORMAT,
  time_short: ISO_TIME_PART_FORMAT,
  // 년
  year: "yyyy",
  year_yearMin: "yy",
  // 년, 월
  year_month: "yyyy-MM",
  year_month_yearMin: "yy-MM",
  year_month_short: "yyyy-MM",
  year_month_yearMin_short: "yy-MM",
  month: "yyyy-MM",
  // 월만 사용하는 것은 valid 하지 않아서 년도 함께 있음.
  // 월, 일
  month_day: "MM-dd",
  month_day_short: "MM-dd",
  month_day_weekday: "MM-dd",
  month_day_weekday_short: "MM-dd",
  // 일
  day_of_month: "do",
  // 년, 월, 일
  date: ISO_DATE_PART_FORMAT,
  date_short: ISO_DATE_PART_FORMAT,
  date_yearMin_short: ISO_DATE_PART_FORMAT,
  date_weekday: ISO_DATE_PART_FORMAT,
  date_weekday_short: ISO_DATE_PART_FORMAT,
  // 년, 월, 일, 시간
  datetime: ISO_DATE_TIME_PART_FORMAT,
  datetime_short: ISO_DATE_TIME_PART_FORMAT,
  datetime_seconds: ISO_DATE_TIME_PART_FORMAT,
  datetime_seconds_short: ISO_DATE_TIME_PART_FORMAT,
  datetime_weekday: ISO_DATE_TIME_PART_FORMAT,
  datetime_weekday_short: ISO_DATE_TIME_PART_FORMAT,
  // 월, 일, 시간은 datetime 속성에 valid 하지 않기 때문에 년, 월, 일, 시간으로 표현합니다.
  // https://developer.mozilla.org/en-US/docs/Web/HTML/Element/time
  month_day_time: ISO_DATE_TIME_PART_FORMAT,
  month_day_time_short: ISO_DATE_TIME_PART_FORMAT,
  month_day_time_weekday: ISO_DATE_TIME_PART_FORMAT,
  month_day_time_weekday_short: ISO_DATE_TIME_PART_FORMAT
};

export { Time as default };
//# sourceMappingURL=index.mjs.map
